import React, { useEffect, useContext } from 'react';
import { useForm, useStep } from "react-hooks-helper";
import { useSelector } from 'react-redux';
import { GlobalContext } from 'store/context/GlobalContext';
import Step1 from './Step1';
import Step2 from './Step2';
import { isMobile } from 'react-device-detect';

const steps = [
    { id: "step1" },
    { id: "step2" },
];

const defaultData = {
    login_id: "",
    event_id: "",
    exchange_list: [],
    // form_name: "",
    // form_phone: "",
    // form_email: "",
    // form_address: "",
    device: isMobile ? "m" : "pc",
};

const MultiStepForm = ({awardsData, fetchawardsData}) => {
    const { step, navigation } = useStep({ initialStep: 0, steps });
    const { id } = step;
    const user = useSelector((state) => state.Auth.user);
    const context = useContext(GlobalContext);
    const { userData } = context;
    const [ formData, setForm ] = useForm(defaultData);

    useEffect(() => {
        setForm({target: {name: 'event_id', value: userData.event_id}});
        setForm({target: {name: 'form_name', value: userData.form_name}});
        setForm({target: {name: 'form_phone', value: userData.form_phone}});
        setForm({target: {name: 'form_email', value: userData.form_email}});
        setForm({target: {name: 'form_address', value: userData.form_address}});
    }, [userData]);

    useEffect(() => {
        setForm({target: {name: 'login_id', value: user.login_id}});
    }, [user])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [step]);

    const props = { formData, setForm, navigation, awardsData, fetchawardsData };

    switch (id) {
        case "step1":
          return <Step1 {...props} />;
        case "step2":
          return <Step2 {...props} />;
        default:
          return null;
      }
};

export default MultiStepForm;